import { jsx as _jsx } from "react/jsx-runtime";
import ProfileContainer from "@components/profile-container";
import React from "react";
var CompanyProfile = function(param) {
    var guestData = param.guestData, company = param.company, tombstoneComponents = param.tombstoneComponents;
    return /*#__PURE__*/ _jsx(ProfileContainer, {
        isResultPage: true,
        guestData: guestData,
        profileData: company,
        tombstoneComponents: tombstoneComponents,
        type: "companies"
    });
};
export var __N_SSG = true;
export default CompanyProfile;
